import axios from 'axios'

const request = axios.create({
  baseURL: `${process.env.SYSTEME_IO_HOST}/dashboard/editor/api`,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

export default request
